import { Box, Button, IconButton, Modal } from "@mui/material";
import { Icon } from "components/Icons";
import PropTypes from "prop-types";
import React from "react";
import Unit from "./Unit.model";
import { Slider } from "components/MaximizedGallery/MaximizedGallery.Slider";
import { getFocus, useAtom, useGet } from "state/jotai";
import { active_project, current_language, map_State } from "state/store.global";
import { _project } from "state/store.projects";
import { isIframeMode } from "logging/logging";


const NavMapModal = ({ sx }) => {
  const setOpen = useAtom(map_State)[1];
 const iFrameEnabled = isIframeMode();
  const language = useAtom(current_language)[0];

  const { pin, pid } = useGet(active_project) 
  const buttonsLabel  = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  const handleOpen = () => setOpen(true);

  return (
    <div>
      <Button
       disableRipple
       disableFocusRipple
        onClick={handleOpen}
        sx={{
            margin: 0,         // Remove any margin
            paddingLeft:"8px",
        paddingRight:"0px",
            minWidth: 0,       // Reset default MUI button width
        //   height: '40px',
        //   flexDirection: "row",
        //   gap: '5px',
         backgroundColor:iFrameEnabled ? "#ffffffbf" : `${clr?.primary}bf`,
        //   borderRadius: "6px",
       color:iFrameEnabled ? "#000" : "#FFFFFF",
          py: "0px",
        //   px: "16px",
        //   lineHeight: 1,
        //   fontWeight: 400,
        //   fontSize: 14,
        boxShadow: "none",
          // transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out;",
          "&:hover": {
            backgroundColor:iFrameEnabled ? "#ffffffbf" : `${clr?.primary}bf`,
           color:iFrameEnabled ? "#000" : "#FFFFFF",
            // transform: "scale(1.1)",
            opacity: 1,
            boxShadow: "none",
          },
          ...sx
        }}
      >
        <span className="icon-hover-effect" style={{ paddingTop: "4px" }}>
          <Icon icon="map" size={"24px"} />
        </span>
       
      </Button>
    </div>
  );
};

NavMapModal.propTypes = {
  unit: PropTypes.instanceOf(Unit).isRequired,
};

export { NavMapModal };
